/**
 * @module FE-CU01_ログイン画面
 */
import Header from '../../../components/header/Header.vue';
import News from '../../../components/news/News.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../../api/nativeApi';
import NativeCallback from '../../../api/nativeCallback';
import PasscodeBioAuthDialog from './modal/passcodeBioAuthDialog.vue';
import TimeParser from '../../../utile/timeParser';
import ExternalUrl from '../../../api/externalLinks/externalUrls';

const PAGE_ID = 'FE-CU01';

export default {
  name: 'Login',
  components: {
    Header,
    News,
    PcPageTitle,
    PCFooter,
    PasscodeBioAuthDialog,
  },
  data: () => ({
    title: '',
    invalid: false,
    callbackResult: {
      nativeAppInfo: {
        errorCode: '',
        nativeVersion: '',
        loginMethod: '', // "0": id/pw毎回入力, "1": id省略, "2": パスコード・生体認証
        deviceToken: '',
        isPushNotificationAvailable: '',
        isBiometricAuthAvailable: '', // "0": 未対応端末, "1": 利用可能, "-1": 数回間違えたのでNativeでロック中, "-2": 未登録
        isPasscodeAuthAvailable: '',
      },
      accountInfo: {
        errorCode: '',
        userId: '',
        password: '',
        terminalInfo: '',
      },
      biometricAuth: {
        errorCode: '',
      },
      passcodeAuth: {
        errorCode: '',
      },
      accountInfoRegisterResult: {
        errorCode: '',
      },
    },
    name: '',
    password: '',
    passcode: '', // パスコード認証用
    isGoTop: false, // true: top画面に遷移、false: 2段階認証画面に遷移
    isMemorize: false, // ユーザーIDを記録するかどうかを判定するフラグ
    showPassword: false,
    isPasscodeBioAuthVisible: false,
    isPasscodeBioAuthDialogVisible: false,
    bioAuthButtonIsVisible: true, // パスコード・生体認証ダイアログにて「生体認証」ボタンの表示を切り替え
    bioAuthButtonIsActive: true, // パスコード・生体認証ダイアログにて「生体認証」ボタンの活性を切り替え
    isFromLogout: false,
    newsInfo: [],
    uiVersion: '',
    isClickLoginButton: false,
    isShowPasscodeAuth: false,
    isFromLogoutBioCheck: '',
    mouseUpFlag: false,
    closeSplashFlg: false,
    isCancelPasscode: false,
    doBiometricAuth: false, // 生体認証を行った場合true
  }),
  computed: {
    lifeCycleState() {
      return this.$store.getters['appInfo/getLifeCycleState'];
    },
    isOnlyPasscodeAuthVisible() {
      const bio = this.callbackResult.nativeAppInfo.isBiometricAuthAvailable;
      return bio === '0' || bio === '-2';
    },
    isValid() {
      if (this.isClickLoginButton) {
        return false;
      }

      const isInputOk = this.name !== '' && this.password !== '';
      return isInputOk ? true : false;

      // Note: I commented these lines to disabled login button when close bio + passcode
      // if (this.isPasscodeBioAuthVisible) {
      //   return true;
      // } else {
      //   const isInputOk = this.name !== '' && this.password !== '';
      //   return isInputOk ? true : false;
      // }
    },
    version() {
      if (this.$isMobileApp) {
        return (
          'App Ver: ' +
          this.$store.getters['appInfo/getNativeVersion'] +
          '/ UI Ver: ' +
          this.uiVersion
        );
      } else {
        return 'Ver: ' + this.uiVersion;
      }
    },
    disabledLoginButtonFlag() {
      return this.checkFilledInput();
    },
    /**
     * ユーザーID バリデーションチェック
     * @returns
     */
    nameRules() {
      return [
        !!this.name || this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU01ログイン画面.E0001'),
      ];
    },
    /**
     * パスワード バリデーションチェック
     * @returns
     */
    passwordRules() {
      return [
        !!this.password || this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU01ログイン画面.E0004'),
      ];
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * ログイン処理
     */
    async login() {
      // ログインボタン押下時
      // 以前にログインしているユーザは強制的にログアウト, SPではログイン方法を選択可能, メンテナンスWEBでユーザ有効状態を無効にした場合はログイン不可
      // 認証失敗時, CU1-E00007表示. 認証成功時, 端末とIDの組み合わせで初めてログインする場合は2段階認証画面、端末で二回目以降のログインの場合はトップ画面に遷移

      // ログインボタンを連打できないようにする
      this.isClickLoginButton = true;

      if (this.$isBrowser) {
        await this.browserLogin();
      } else {
        if (!this.isPasscodeBioAuthVisible || this.isCancelPasscode) {
          await this.APP_CU0102_PASSWORD();
          return;
        }

        if (this.isShowPasscodeAuth) {
          await this.openPasscodeAuthDialog();
        } else {
          await this.openBioAuthDialog();
        }
      }
    },
    /**
     * モバイル版ログイン処理
     */
    async mobileLogin() {
      this.$store.commit('setIsLoggedIn', { isLoggedIn: true }); //sessionStorage更新をログイン判定に用いる

      if (this.isGoTop) {
        if (sessionStorage.getItem('redirectPath')) {
          // redirect to notificationHistory page when tap from panel
          this.$router.push({
            path: sessionStorage.getItem('redirectPath'),
          });
        } else {
          this.$router.push({
            path: '/top',
            query: { obj: { from: 'login' } },
          });
        }
      } else {
        // ID/PWを入力した時も、生体認証時も通る。。。
        // クエリパラメータではなくstoreで受け渡しする
        let setUserId, setPassword;
        if (this.name != '') {
          setUserId = this.name;
        } else if (this.callbackResult.accountInfo.userId != '') {
          setUserId = this.callbackResult.accountInfo.userId;
        } else {
          //ありえない遷移
          setUserId = '';
        }
        if (this.password != '') {
          setPassword = this.password;
        } else if (this.callbackResult.accountInfo.password != '') {
          setPassword = this.callbackResult.accountInfo.password;
        } else {
          //ありえない遷移
          setPassword = '';
        }

        this.$store.commit('appInfo/setUsedLoginData', {
          userId: setUserId,
          password: setPassword,
        });

        // reset login method if login by account that different from before account
        NativeApi.registerLoginSetting(0, '', '');

        this.$router.push({
          path: '/twoStepAuthentication',
        });
      }
    },
    /**
     * パスコード認証ダイアログ表示_キャンセルのみ
     */
    async openPasscodeAuthDialog() {
      // 「キャンセル」のみが表示されたダイアログ
      this.isPasscodeBioAuthDialogVisible = true;
    },
    /**
     * パスコード認証ダイアログ表示_生体認証ボタン非活性
     */
    async openPasscodeBioAuthDialogBioAuthInvalid() {
      // 「キャンセル」と非活性な「生体認証」が表示されたダイアログ
      // this.bioAuthButtonIsActive = false;
      this.isPasscodeBioAuthDialogVisible = true;
    },
    /**
     * パスコード認証ダイアログ表示_生体認証ボタン活性
     * @param {object} autoOpenObj 自動オープン情報
     */
    async openPasscodeBioAuthDialog(autoOpenObj) {
      // 「キャンセル」と活性な「生体認証」が表示されたダイアログ
      this.bioAuthButtonIsActive = true;
      this.isPasscodeBioAuthDialogVisible = true;
      // if (autoOpenObj.autoOpenDialog && !this.isFromLogout) {
      if (autoOpenObj.autoOpenDialog) {
        // TODO: Need confirm spec because old logic is still reasonable
        // 初期表示かつ、ログアウト後ではない場合
        NativeApi.requestBiometricAuth(); // -> watch"callbackResult.biometricAuth"
      }
    },
    /**
     * 生体認証ダイアログ表示
     */
    async openBioAuthDialog() {
      NativeApi.requestBiometricAuth();
    },
    /**
     * 生体認証実行
     */
    async startBioAuth() {
      // 生体認証ダイアログはNative側で表示処理を行う
      NativeApi.requestBiometricAuth(); // -> watch"callbackResult.biometricAuth"
      // this.isPasscodeBioAuthDialogVisible = false;
    },
    /**
     * パスコード_生体認証ダイアログのキャンセルボタン押下時
     */
    async cancelPasscodeBioAuthDialog() {
      this.passcode = '';

      // id/pwによるログインを可能にする
      this.isPasscodeBioAuthDialogVisible = false;
      this.isCancelPasscode = true;
      // this.isPasscodeBioAuthVisible = false;
    },
    /**
     * エラーメッセージダイアログ表示
     * @param {String} messageID エラーメッセージID
     */
    async openErrorDialog(messageID) {
      this.isClickLoginButton = false;
      let msg;
      if (messageID === 'FE-CU1-E0007') {
        msg = '$vuetify.メッセージ一覧.FECU01ログイン画面.E0007';
        //  "ログインに失敗しました。";
      } else if (messageID === 'FE-CU1-E0008') {
        msg = '$vuetify.メッセージ一覧.FECU01ログイン画面.E0008';
        // "OSにより生体認証がロックされており、利用できません。";
      } else if (messageID === 'FE-CU1-E0010') {
        msg = '$vuetify.メッセージ一覧.FECU01ログイン画面.E0010';
        // "認証に失敗しました。一定時間、パスコード認証をご利用頂けません。";
      } else if (messageID === 'FE-CU1-E0011') {
        msg = '$vuetify.メッセージ一覧.FECU01ログイン画面.E0011';
        // "パスコードが間違っています。もう1度パスコードを入力して下さい。";
      } else if (messageID === 'FE-NV1-E0001') {
        msg = '$vuetify.メッセージ一覧.FENV01ログイン画面.E0001';
      }
      await this.$errorDialog(msg);
      if (messageID === 'FE-CU1-E0007' || messageID === 'FE-CU1-E0011') {
        // 何もしない
      } else if (messageID === 'FE-CU1-E0008') {
        // this.bioAuthButtonIsActive = false; // すでにダイアログが開いているため //TODOキーボード起動
        // await this.openPasscodeBioAuthDialogBioAuthInvalid();
      } else if (messageID === 'FE-CU1-E0010') {
        this.changePasswordAuthDisplay();
      }
    },
    /**
     * パスワード認証へ表示切り替え
     */
    changePasswordAuthDisplay() {
      this.isPasscodeBioAuthVisible = false;
    },
    /**
     * パスコード_生体認証へ表示切り替え
     */
    changePasscodeBioInputDisplay() {
      this.isPasscodeBioAuthVisible = true;
    },
    /**
     * バリデーション処理
     */
    validate() {
      this.$refs.form.validate();
    },
    /**
     * フォーム入力リセット
     */
    reset() {
      this.$refs.form.reset();
    },
    /**
     * フォームバリデーションリセット
     */
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    lockUser() {
      // console.log("called");
    },
    /**
     * CU0103のAPI実行
     * @param {String} param リクエストURL
     * @param {Array} queries リクエストパラメータ
     * @param {String} method リクエストメソッド
     * @returns apiData レスポンスデータ
     */
    APP_CU0103: async function (param, queries, method) {
      // this.$_setLoading(true); // Loadingが止まらないのでコメントアウト
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     newsInfo: [
            //       {
            //         newsTitle: "メンテナンスのお知らせ",
            //         newsContent:
            //           "サーバーメンテナンスのため一時的にアプリ利用ができなくなります。警備機器ホームアルソックXS をご利用のお客様は ALSOKホームページをご確認ください。",
            //         newsDateTime: "2022-05-30 16:12",
            //       },
            //       {
            //         newsTitle: "バージョンアップのお知らせ",
            //         newsContent:
            //           "アプリバージョン ver2.0.3を公開予定です。古いアプリは利用できなくなります。",
            //         newsDateTime: "2020-01-10 06:00",
            //       },
            //     ],
            //   },
            // };

            // データ整形
            await apiData.contentsInfo.newsInfo.forEach((element, index) => {
              const date = TimeParser(element.newsDateTime);
              this.newsInfo.push({
                id: index,
                newsTitle: element.newsTitle,
                newsContent: element.newsContent,
                newsDateTime: {
                  year: date.year,
                  month: date.month,
                  day: date.day,
                  hour: date.hour,
                  minutes: date.minutes,
                },
              });
            });
            setTimeout(() => {
              let aTags = document.querySelectorAll('.news-list-area a');
              for (let aTag of aTags) {
                aTag.onclick = function (e) {
                  e.preventDefault();
                  NativeApi.openBrowserApp(aTag.href);
                };
              }
            }, 100);
            // アプリのバージョンが記載された外部ファイルを取得しバージョン情報を画面に出力する。
            // 1. レスポンスステータス200の場合
            // 画面レイアウトNo.69「バージョン情報」を出力する。
            // 2. 1.以外の場合
            // 画面レイアウトNo.69「バージョン情報」を非表示にする。

            if (this.$isBrowser) {
              if (this.$cookie.get('userId')) {
                this.isMemorize = true;
                this.name = this.$cookie.get('userId');
              }
            }
          },
          () => {
            // 異常系の処理については、FE-CU2_共通項目を参照。
            //お知らせのエラーは全部無視#27114
            //this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          if (this.$isMobileApp) {
            NativeApi.requestNativeAppInfo(); // 呼び出し後の処理はwatch:"callbackResult.nativeAppInfo"
          }
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * ブラウザアプリログイン処理
     */
    browserLogin: async function () {
      // APP_CU0101の実行
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/customerLogin/login';

      let queries = {
        userId: this.name,
        password: this.password,
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     loginResult: 1,
            //   },
            //   token: "token",
            // };

            if (this.isMemorize) {
              this.$cookie.set('userId', this.name);
            } else {
              this.$cookie.delete('userId');
            }

            if (apiData.contentsInfo.loginResult == 0) {
              sessionStorage.setItem('token', apiData.token);
              this.$store.commit('setIsLoggedIn', { isLoggedIn: true }); //sessionStorage更新をログイン判定に用いる

              // トップ画面に遷移する
              this.$router.push({
                path: '/top',
                query: { from: 'login' },
              });
            } else if (apiData.contentsInfo.loginResult == 1) {
              sessionStorage.setItem('token', apiData.token);

              // クエリパラメータではなくstoreで受け渡しする
              this.$store.commit('appInfo/setUsedLoginData', {
                userId: this.name,
                password: this.password,
              });

              // 二段階認証画面に遷移する
              this.$router.push({
                path: '/twoStepAuthentication',
              });
            } else {
              this.openErrorDialog('FE-CU1-E0007');
            }
          },
          (error) => {
            // ネットワークエラー、タイムアウトの場合は処理終了
            if (error.message === 'Network Error') {
              this.openErrorDialog('FE-NV1-E0001');
            }

            if (error.response.status == '400' || error.response.status == '500') {
              this.openErrorDialog('FE-CU1-E0007');
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * パスコード_生体認証によるCU0102のAPI実行
     */
    APP_CU0102_PASSCODE_BIO: async function () {
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/customerLogin/appLogin';

      let queries = {
        userId: this.callbackResult.accountInfo.userId,
        password: this.callbackResult.accountInfo.password,
        terminalInfo: this.callbackResult.accountInfo.terminalInfo,
        deviceToken: this.callbackResult.nativeAppInfo.deviceToken,
        deviceOS: this.$store.getters['appInfo/getDeviceOs'],
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            const isLoginSuccess = apiData.contentsInfo.loginResult;
            if (isLoginSuccess === 0 || isLoginSuccess === 1) {
              //遷移先を更新
              this.isGoTop = isLoginSuccess === 0 ? true : false;

              if (isLoginSuccess === 1) {
                //#29011 2段階認証が必要な場合、明示的にterminalInfo を削除
                localStorage.setItem('terminalInfo', '');
                //#29011 生体認証/パスコード認証時、2段階認証が必要になったフラグ
                localStorage.setItem('invalidTerminalInfoForBiometricAuth', true);
              } else {
                // ログイン成功:0
                // #30433 「this.callbackResult.accountInfo.terminalInfo」を、localStorageへ上書き(ログインAPI時にこれを使用しているので)
                localStorage.setItem('terminalInfo', this.callbackResult.accountInfo.terminalInfo);
              }

              // JWTトークンをsessionStorageに保存する。
              sessionStorage.setItem('token', apiData.token);

              const id = this.callbackResult.accountInfo.userId;
              const pass = this.callbackResult.accountInfo.password;
              // #30433 ログイン成功:0 は使用したterminalInfoを記憶、2段階認証が必要:1の場合は意図的に空白にする
              const terminal =
                isLoginSuccess === 0 ? this.callbackResult.accountInfo.terminalInfo : '';

              NativeApi.registerAccountInfo(id, pass, terminal); // -> watch:"callbackResult.accountInfoRegisterResult"
            } else {
              this.openErrorDialog('FE-CU1-E0007');
              this.isPasscodeBioAuthVisible = false;
            }
          },
          (error) => {
            // ネットワークエラー、タイムアウトの場合は処理終了
            if (error.message === 'Network Error') {
              this.openErrorDialog('FE-NV1-E0001');
            }

            if (error.response.status == '400' || error.response.status == '500') {
              this.openErrorDialog('FE-CU1-E0007');
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * パスワードによるCU0102のAPI実行
     */
    APP_CU0102_PASSWORD: async function () {
      if (!this.$isMobileApp) return;
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/customerLogin/appLogin';

      let queries = {
        userId: this.name,
        password: this.password,
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceToken: this.callbackResult.nativeAppInfo.deviceToken,
        deviceOS: this.$store.getters['appInfo/getDeviceOs'],
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     loginResult: 0,
            //   },
            //   token: "token",
            // };

            // JWTトークンをsessionStorageに保存する。
            sessionStorage.setItem('token', apiData.token);

            // 遷移先を指定
            const isLoginSuccess = apiData.contentsInfo.loginResult;
            if (isLoginSuccess === 0 || isLoginSuccess === 1) {
              this.isGoTop = isLoginSuccess === 0 ? true : false; //0: 成功, 1: 2段階認証が必要

              if (isLoginSuccess === 1) {
                //#29011 2段階認証が必要な場合、明示的にterminalInfo を削除
                localStorage.setItem('terminalInfo', '');
                //#29011 生体認証/パスコード認証時、2段階認証が必要になったフラグ
                localStorage.setItem('invalidTerminalInfoForBiometricAuth', true);
              }
              // #30473 ID/PWを毎回入力/IDは覚える設定の時ここを通る。この時はアプリ側のterminalInfoではなくLocalStorageのterminalInfoを使用するため処理を戻す。
              /* else {
                // ログイン成功:0
                // #30433 「this.callbackResult.accountInfo.terminalInfo」を、localStorageへ上書き(ログインAPI時にこれを使用しているので)
                // localStorage.setItem('terminalInfo', this.callbackResult.accountInfo.terminalInfo);
              } */

              // NativeAPIに情報を渡す
              const id = this.name; // 入力値、あるいは、NativeCallbackからの値が保持されている
              const pass = this.password;
              // #30473 ID/PWを毎回入力/IDは覚える設定の時ここを通る。この時はアプリ側のterminalInfoではなくLocalStorageのterminalInfoを使用するため処理を戻す。
              // #30433 ログイン成功:0 は使用したterminalInfoを記憶、2段階認証が必要:1の場合は意図的に空白にする
              // const terminal =
              //   isLoginSuccess === 0 ? this.callbackResult.accountInfo.terminalInfo : '';
              const terminal = localStorage.getItem('terminalInfo')
                ? localStorage.getItem('terminalInfo')
                : '';

              NativeApi.registerAccountInfo(id, pass, terminal); // -> watch:"callbackResult.accountInfoRegisterResult"
            } else {
              this.openErrorDialog('FE-CU1-E0007');
            }
          },
          (error) => {
            // ネットワークエラー、タイムアウトの場合は処理終了
            if (error.message === 'Network Error') {
              this.openErrorDialog('FE-NV1-E0001');
            }

            if (error.response.status == '400' || error.response.status == '500') {
              this.openErrorDialog('FE-CU1-E0007');
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * Sorry画面へ遷移
     */
    goSorry: function () {
      this.$router.push({
        path: '/sorry',
      });
    },
    /**
     * パスワードテキストEnter時処理
     */
    loginTrigger() {
      if (!document.getElementById('login-buttun').disabled) {
        this.login();
      }
    },
    /**
     * マウスオーバー時の処理
     */
    mouseOver() {
      this.mouseUpFlag = false;
    },
    /**
     * マウスアップ時の処理
     */
    mouseUp() {
      this.mouseUpFlag = true;
    },
    /**
     * ユーザーIDテキストEnter時処理
     */
    moveNext() {
      document.querySelector('#password-input').focus();
    },
    /**
     * 利用規約ページへ遷移
     */
    async goApprovalTermsPage() {
      if (this.$isMobileApp) {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU01ログイン画面.C0001',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );
        if (result) {
          let approvalTermsUrl = ExternalUrl.alsockWebAppApprovalTerms;
          NativeApi.openBrowserApp(approvalTermsUrl);
          this.$router.push('/Login');
        }
      } else {
        this.$router.push('/approvalTerms');
      }
    },
    /**
     * パスワード初期化画面へ遷移
     */
    async goForgotPasswordPage() {
      if (this.$isMobileApp) {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU01ログイン画面.C0002',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );
        if (result) {
          let forgotPasswordUrl = ExternalUrl.alsockWebAppPasswordInitUserIdEntry;
          NativeApi.openBrowserApp(forgotPasswordUrl);
          this.$router.push('/Login');
        }
      } else {
        this.$router.push('/PasswordInitUserIdEntry');
      }
    },
    /**
     * #29557 [修正管理表No.43] ユーザーマニュアルボタン押下時処理
     */
    async goManualPage() {
      let displayLang = localStorage.getItem('lang');
      let manualUri = displayLang === 'en' ? ExternalUrl.manualEn : ExternalUrl.manual;
      if (this.$isMobileApp) {
        NativeApi.openBrowserApp(manualUri);
      } else {
        window.open(manualUri, '_blank');
      }
    },
    /**
     * パスコード_生体認証ダイアログ表示可否チェック
     * @returns boolean 判定結果
     */
    async checkOpenBioPasscodeAuthDialog() {
      this.bioAuthButtonIsActive = false;
      if (!this.closeSplashFlg) {
        return;
      }
      const bio = this.callbackResult.nativeAppInfo.isBiometricAuthAvailable;
      if (bio === '0' || bio === '-2') {
        this.checkOpenPasscodeAuthDialog();
      }

      if (bio === '1') {
        this.changePasscodeBioInputDisplay();
        this.openBioAuthDialog();
        this.bioAuthButtonIsActive = true;
      }

      if (bio === '-1') {
        // await this.$messageDialog('error', 'Bio disabled', 'OK');
        this.checkOpenPasscodeAuthDialog();
      }
    },
    /**
     * パスコードダイアログ表示可否チェック
     * @returns boolean 判定結果
     */
    async checkOpenPasscodeAuthDialog() {
      const isPasscodeAuthAvailable = this.callbackResult.nativeAppInfo.isPasscodeAuthAvailable;
      if (isPasscodeAuthAvailable === '1') {
        this.changePasscodeBioInputDisplay();
        this.isShowPasscodeAuth = true;
        this.openPasscodeAuthDialog();
        return;
      }

      this.isPasscodeBioAuthVisible = false;
    },
    /**
     * ログインIDとパスワードの入力チェック
     * @returns boolean 判定結果
     */
    checkFilledInput() {
      if (this.name === '' || this.password === '') {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    // IF04NativeCallbackの完了を監視
    async 'callbackResult.nativeAppInfo'(newVal, oldVal) {
      if (oldVal.errorCode !== '') return;

      // Storeに保存
      this.$store.commit('appInfo/setNativeAppInfo', newVal);
      this.$store.commit('appInfo/setDeviceOs', this.$isAndroidApp ? 1 : 2); // 1: AndroidからのNaviveCallback, 2: iSOからのNaviveCallback

      // 以下、初期処理
      const code = newVal.errorCode;
      const method = newVal.loginMethod;
      if (this.$isMobileApp) {
        NativeApi.closeSplash();
      }

      if (NativeCallback.codeInclude(code, '04-C0000')) {
        if (method === '0') {
          // ユーザーID/PWを毎回入力する画面表示
          this.changePasswordAuthDisplay();
        } else if (method === '1') {
          // ユーザーIDにあらかじめ入力された状態の画面表示
          NativeApi.requestAccountInfo(); // -> watch"callbackResult.accountInfo"
        } else if (method === '2') {
          this.checkOpenBioPasscodeAuthDialog(newVal);
        }
      } else if (NativeCallback.codeInclude(code, '04-E9999')) {
        this.goSorry();
      }
    },
    async 'callbackResult.accountInfo'(newVal) {
      //biometricAuth で成功後
      // if fail -> there is exist a old value errorCode. Next request wil not pass because there is always exist old value errorCode before. So I comment the line below
      // if (oldVal.errorCode !== '') return;

      // 二段階認証画面でVuexを用いて初回ログインの判定を行うため、ここではcommitしない。本画面で、二段階認証画面以外の画面に遷移するときにcommitする(beforeRouteLeave参照)
      // this.$store.commit("appInfo/setAccountInfo", newVal);

      if (this.isPasscodeBioAuthVisible) {
        // パスコードまたは生体認証でログイン処理を行う場合
        await this.APP_CU0102_PASSCODE_BIO();
      } else {
        // ユーザーIDを毎回入力する場合, NativeApi.requestAccountInfoが呼ばれないのでelseで問題ない
        this.name = newVal.userId;
      }
    },
    async 'callbackResult.biometricAuth'(newVal) {
      // 生体認証後
      // if fail -> there is exist a old value errorCode. Next request wil not pass because there is always exist old value errorCode before. So I comment the line below
      // if (oldVal.errorCode !== '') return;
      this.doBiometricAuth = false;
      if (NativeCallback.codeInclude(newVal.errorCode, '06-C0000')) {
        // 生体認証成功
        // 行先はひとまずTOP画面(terminalInfoが無効になっている可能性もあるが)
        this.isGoTop = true;
        this.doBiometricAuth = true;
        // NativeからID/PW/token取得
        const requestPassword = 1; // 0: パスワード不要, 1: パスワード必要 // TODOchangeDommyInput
        NativeApi.requestAccountInfo(requestPassword); // -> watch"callbackResult.accountInfo"
      } else if (NativeCallback.codeInclude(newVal.errorCode, '06-E0001')) {
        // 生体認証キャンセルのとき
        //await this.openPasscodeBioAuthDialogBioAuthInvalid();
        this.checkOpenPasscodeAuthDialog();
      } else if (NativeCallback.codeInclude(newVal.errorCode, '06-E0002')) {
        // 生体認証利用不可のとき
        await this.openErrorDialog('FE-CU1-E0008'); // エラーを閉じた後、パスコード認証ダイアログを表示
        this.bioAuthButtonIsActive = false;
        this.checkOpenPasscodeAuthDialog();
      } else if (NativeCallback.codeInclude(newVal.errorCode, '06-E9999')) {
        this.goSorry();
      }
    },
    async 'callbackResult.passcodeAuth'(newVal) {
      if (NativeCallback.codeInclude(newVal.errorCode, '07-C0000')) {
        // パスコード認証成功のとき
        this.isGoTop = true;
        const requestPassword = 1; // 0: パスワード不要, 1: パスワード必要 // TODOchangeDommyInput
        NativeApi.requestAccountInfo(requestPassword); // -> watch"callbackResult.accountInfo"
      } else if (NativeCallback.codeInclude(newVal.errorCode, '07-E0001')) {
        // パスコード認証失敗のとき
        await this.openErrorDialog('FE-CU1-E0011');
        this.passcode = '';
        return;
      } else if (NativeCallback.codeInclude(newVal.errorCode, '07-E0002')) {
        // パスコード認証利用不可のとき
        await this.openErrorDialog('FE-CU1-E0010');
        this.passcode = '';
        this.isPasscodeBioAuthDialogVisible = false;
      } else if (NativeCallback.codeInclude(newVal.errorCode, '07-E9999')) {
        this.goSorry();
      }
    },
    async 'callbackResult.accountInfoRegisterResult'(newVal, oldVal) {
      // APP_CU0102_PASSCODE_BIO でログイン成功後
      if (oldVal.errorCode !== '') return;

      if (NativeCallback.codeInclude(newVal.errorCode, '01-C0000')) {
        // this.isGoTop を元に遷移先も判定する。
        await this.mobileLogin();
      } else if (NativeCallback.codeInclude(newVal.errorCode, '01-E9999')) {
        this.goSorry();
      }
    },
    passcode(newVal) {
      if (newVal.length === 4) {
        NativeApi.requestPasscodeAuth(this.passcode);
      }
    },
    lifeCycleState: {
      async handler(newVal) {
        if (
          NativeCallback.codeInclude(newVal.errorCode, '11-C0000') &&
          this.callbackResult.nativeAppInfo.isBiometricAuthAvailable === '1' &&
          this.callbackResult.nativeAppInfo.loginMethod === '2' &&
          newVal.appState === 'RESUMED' &&
          this.bioAuthButtonIsActive === true &&
          this.isPasscodeBioAuthVisible === true &&
          this.isPasscodeBioAuthDialogVisible === false
        ) {
          await this.openBioAuthDialog();
        }
      },
      deep: true,
    },
    async isFromLogoutBioCheck() {
      if (!this.isFromLogout || this.callbackResult.nativeAppInfo.loginMethod !== '2') {
        return;
      }

      this.closeSplashFlg = true;
      this.checkOpenBioPasscodeAuthDialog();
    },
    deep: true,
  },
  beforeMount() {
    // Native部との通信を行うCallback関数をwindowオブジェクトに登録
    // IF01_アカウント情報記録要求 //IF02ではなくこちらが正
    window.onRegisterAccountInfoFinished = (errorCode) => {
      this.callbackResult.accountInfoRegisterResult =
        NativeCallback.onRegisterAccountInfoFinished(errorCode);
    };
    // IF04_アプリNative部保持情報要求
    window.onResponseNativeAppInfo = (
      error,
      version,
      login,
      device,
      notice,
      biomAuth,
      passcodeAuth
    ) => {
      this.callbackResult.nativeAppInfo = NativeCallback.onResponseNativeAppInfo(
        error,
        version,
        login,
        device,
        notice,
        biomAuth,
        passcodeAuth
      );
      this.isFromLogoutBioCheck = this.isFromLogout + biomAuth;
      this.$store.commit('appInfo/setNativeAppInfo', { ...this.callbackResult.nativeAppInfo });
    };
    // IF05_アカウント情報要求
    window.onResponseAccountInfo = (errorCode, userId, password, terminalInfo) => {
      this.callbackResult.accountInfo = NativeCallback.onResponseAccountInfo(
        errorCode,
        userId,
        password,
        terminalInfo
      );
    };
    // IF06_生体認証要求
    window.onResponseBiometricAuth = (errorCode) => {
      this.callbackResult.biometricAuth = NativeCallback.onResponseBiometricAuth(errorCode);
    };
    // IF07_パスコード認証要求
    window.onResponsePasscodeAuth = (errorCode) => {
      this.callbackResult.passcodeAuth = NativeCallback.onResponsePasscodeAuth(errorCode);
    };
    // IF08_スプラッシュ画面Close要求
    window.onCloseSplashFinished = async (error) => {
      const splash = NativeCallback.onCloseSplashFinished(error);
      if (NativeCallback.codeInclude(splash.errorCode, '08-E9999')) {
        this.goSorry();
        return;
      }

      if (this.isFromLogout) {
        return;
      }

      this.closeSplashFlg = true;
      if (this.callbackResult.nativeAppInfo.loginMethod === '2') {
        this.checkOpenBioPasscodeAuthDialog(this.callbackResult.nativeAppInfo);
      }
    };
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    this.isFromLogout = this.$route.query.isFromLogout;

    // versionファイルの取得
    const file = require('raw-loader!@/../public/version');
    this.uiVersion = file.default;

    // 利用規約チェック、プライバシーポリシーチェックを初期化
    this.$store.state.serviceCheck = false;
    this.$store.state.privacyPolicyCheck = false;

    if (this.$isMobileApp) {
      NativeApi.closeSplash(); // 呼び出し後の処理はwindow.onCloseSplashFinishedに記載
    } else if (sessionStorage.getItem('token') && localStorage.getItem('terminalInfo')) {
      // sessionStorage内に有効トークンが確認でき、かつ、二段階認証済み（ローカルストレージに端末情報がある）の場合, TOPに遷移
      this.$router.push({
        path: '/top',
        query: { from: 'login' },
      });
    }

    // 正常系を確認したい場合は下記のコメントを解除する
    let param = '/api/customerLogin/getNewsInfo';
    let queries = {};

    let method = 'get';
    await this.APP_CU0103(param, queries, method);
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/twoStepAuthentication' || this.doBiometricAuth) {
      if (this.$isMobileApp) {
        this.$store.commit('appInfo/setAccountInfo', this.callbackResult.accountInfo);
      }
    }
    next();
  },
};
